/* eslint-disable react/prop-types */
import { Button } from "@mui/material";
import { FC, ReactNode, useContext } from "react";
import { PPProps } from "./PPField";
import { v4 } from "uuid";
import {
  ExtendedEvents,
  FunctionDefinition,
  NameValueTuple,
} from "../model/form-configuration";
import { funcExecutor } from "../../functions/generic-functions";
import { useFormContext } from "react-hook-form";
import {
  AppContextType,
  StateContext,
  StateContextType,
} from "../../context/ApplicationContext";
import { useSearchParams } from "react-router-dom";
import { cloneDeep, isEqual } from "lodash";

type ButtonType = "submit" | "reset" | "button" | undefined;

const PPButton: FC<{ props: PPProps }> = ({ props }) => {
  const [queryParams] = useSearchParams();
  const { getValues, setValue } = useFormContext();
  const stateCtx: StateContextType = useContext(StateContext);

  const buttonType: ButtonType = props.extendedAttributes
    ?.buttonType as ButtonType;

  const getParameter = (nameValue: NameValueTuple): any => {
    let param: any = undefined;
    switch (nameValue.type) {
      case "string":
        param = getString(nameValue);
        break;
      case "stringArray":
        param = getStringArray(nameValue);
        break;
      case "rpn":
        param = getExpression(nameValue);
        break;
      default:
        param = nameValue.value;
    }
    return param;
  };

  const getString = (nameValue: NameValueTuple): string => nameValue.value;

  const getExpression = (nameValue: NameValueTuple): string => nameValue.value;

  const getStringArray = (nameValue: NameValueTuple): string[] => {
    const stringArrRegEx: RegExp = /\[(.*?)\]/;
    const stringVals: RegExpMatchArray | null =
      nameValue.value.match(stringArrRegEx);
    if (stringVals !== null) {
      return stringVals[1].split(",");
    } else return [] as string[];
  };

  const onClick = (appContext: AppContextType) => {
    const events: ExtendedEvents | undefined = props.extendedEvents;

    if (events?.onClick) {
      const functions: FunctionDefinition[] = events?.onClick;
      const sortedFunctions: FunctionDefinition[] = functions
        .slice()
        .sort(
          (a: FunctionDefinition, b: FunctionDefinition) => a.order - b.order
        );

      sortedFunctions.forEach((func: FunctionDefinition) => {
        const sortedParams: NameValueTuple[] = func.parameters
          .slice()
          .sort((a: NameValueTuple, b: NameValueTuple) => a.order - b.order);

        funcExecutor(
          func.name,
          sortedParams.map((nameValue: NameValueTuple): any =>
            getParameter(nameValue)
          ),
          getValues,
          setValue,
          appContext,
          undefined,
          undefined,
          undefined,
          queryParams
        );
      });
    }
  };

  return (
    <Button
      type={buttonType ?? "button"}
      onClick={
        buttonType == undefined
          ? () => {
              const newAppContext: AppContextType = cloneDeep(
                stateCtx.applicationContext
              );
              onClick(newAppContext);
              if (!isEqual(stateCtx.applicationContext, newAppContext))
                stateCtx.setApplicationContext(newAppContext);
            }
          : undefined
      }
    >
      {props.label}
    </Button>
  );
};

export default PPButton;
//PPButton.whyDidYouRender = true;
